export default __webpack_public_path__ + "c0484805d353883f8b119ab55371ed05.svg";